import { render, staticRenderFns } from "./CreateNftGating.vue?vue&type=template&id=37b51312&scoped=true&"
import script from "./CreateNftGating.vue?vue&type=script&lang=js&"
export * from "./CreateNftGating.vue?vue&type=script&lang=js&"
import style0 from "./CreateNftGating.vue?vue&type=style&index=0&id=37b51312&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b51312",
  null
  
)

export default component.exports